import { Component, OnInit } from '@angular/core';
import { IWGSharedService } from '../../../shared/services/shared.service';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-user-links',
  templateUrl: './user-links.component.html',
  styleUrls: ['./user-links.component.scss']
})
export class UserLinksComponent implements OnInit {

  isLoading = false;  
  userLinks: any = [];
  constructor(
    private userService:UserService, private sharedService: IWGSharedService
  ) { }

  ngOnInit(): void {
    this.userService.getUserLinks({isArray: false, cancellable: true})
    .subscribe(
      data=>{        
        if(data.apiCallStatus != 1){
          return;
        }
        this.userLinks = data.data.Data;
        if(this.userLinks) {
          this.sharedService.setIWGUserLinkStatus((this.userLinks.length > 0));
        } else {
          this.sharedService.setIWGUserLinkStatus(false);
        }
      }
    );
  }

  OnUserLink = (uri) => {
    if (this.sharedService.getMyRateDirty()) {
        if (this.isConfirm()) {
            this.sharedService.setMyRateDirty(false);                          
            window.open(uri,'_blank');
        }
    }
    else {              
        window.open(uri, '_blank');
    }
  }

  isConfirm() {
      return confirm('Are you sure you want to leave the page without submitting?')
  }

}
